import React from 'react';
import { FaHeart, FaComment, FaChevronLeft, FaUsers, FaSearchLocation, FaUserMd, FaPhoneAlt, FaChevronRight, FaGem, FaThumbsUp, FaShareAlt, FaPlayCircle, FaCheckCircle, FaQuoteLeft, FaStar, FaStarHalfAlt, FaBell } from 'react-icons/fa';
import { motion, AnimatePresence } from "framer-motion";
import MainNavbar from '../MainNavbar';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Heart, MessageCircle, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { BiSearch } from 'react-icons/bi';
import './Homepage.css';
import { GiCrystalBall, GiSpy, GiHeartBeats, GiPalm, GiStarsStack, GiMoonOrbit, GiCardJoker, GiPartyPopper } from "react-icons/gi";
import { useContext } from "react";
import AlertContext from "../../../contexts/AlertContext";

const featuresData = [
  {
    id: "perfect-matches",
    icon: <FaHeart className="text-white text-5xl" />,
    title: "Perfect Matches",
    description: "Send connection requests to profiles that perfectly align with your preferences.",
    bgColor: "bg-gradient-to-br from-pink-400 to-pink-500",
  },
  {
    icon: <BiSearch className="text-white text-5xl" />,
    title: "Match Score",
    description: "Get updated match scores daily as new members join the platform.",
  },
  {
    icon: <FaGem className="text-white text-5xl" />,
    title: "Recommended Profiles",
    description: "Follow members to receive updates and view their recommended profiles.",
  },
  {
    id: "chat",
    icon: <FaComment className="text-white text-5xl" />,
    title: "Instant Chat",
    description: "Start real-time conversations to get to know your matches better.",
    bgColor: "bg-gradient-to-br from-purple-400 to-purple-500",
  },
  {
    id: "notification",
    icon: <FaBell className="text-white text-5xl" />,
    title: "Notifications",
    description: "Stay informed with alerts for new matches, messages, and special updates.",
    bgColor: "bg-gradient-to-br from-yellow-400 to-yellow-500",
  },
  {
    icon: <FaUsers className="text-white text-5xl" />,
    title: "Restriction Settings",
    description: "Manage privacy settings such as photo protection and anti-spam options.",
  }
];
const steps = [
  {
    number: 1,
    title: 'Register for Mentor Support',
    description: 'Sign up to get access to experienced mentors who will guide you through the matchmaking journey.',
    color: '#ff4da6',
  },
  {
    number: 2,
    title: 'Get Personalized Guidance',
    description: 'Mentors help you create an impressive biodata and suggest filters based on your preferences.',
    color: '#6b5bff',
  },
  {
    number: 3,
    title: 'Mentor-Assisted Match Search',
    description: 'With mentor support, explore matches and get advice on selecting suitable profiles.',
    color: '#6b5bff',
  },
  {
    number: 4,
    title: 'Support till Marriage',
    description: 'Mentors assist you with the final steps including contacting families and proceeding forconfidence.',
    color: '#ff4da6',
  },
];





const HomePage = () => {
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);
  const [index, setIndex] = useState(0);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [reviews, setReviews] = useState([]);
  const [featuredMembers, setFeaturedMembers] = useState([]);
  const [currentFeatureIndex, setCurrentFeatureIndex] = useState(0);
  const currentFeature = featuresData[currentFeatureIndex];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [selectedType, setSelectedType] = useState({
    age: "",
    occupation: "",
    caste: "",
    location: ""
  });

  const handleChange = (field, value) => {
    setSelectedType({ ...selectedType, [field]: value });
    console.log(`Selected ${field}: ${value}`); // You can keep this for debugging
  };

  const images = [
    "/Images/h2.jpg",
    "/Images/h2.jpg",
    "/Images/h3.jpg",
    "/Images/h4.jpg",
  ];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentFeatureIndex((prevIndex) => (prevIndex + 1) % featuresData.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    const profileCreated = localStorage.getItem('profileCreated');
    if (profileCreated === 'false') {
      setShowProfileModal(true);
    }
  }, []);
  useEffect(() => {
    const fetchFeaturedProfiles = async () => {
      try {
        const res = await axios.get('https://back.varankal.com/auth/featured-profiles');
        if (res.data?.success && res.data?.data) {
          setFeaturedMembers(res.data.data);
        } else {
          console.error('No featured data found.');
        }
      } catch (err) {
        console.error('Error fetching featured profiles:', err);
      }
    };

    fetchFeaturedProfiles();
  }, []);

  const handleProfileClick = async (userId) => {
    console.log("User ID:", userId); // Add this line to check if userId is being passed correctly
    if (!userId) {
      showAlert("User ID is not available.");
      return;
    } try {
      const response = await axios.get(`https://back.varankal.com/user/view-profile/${userId}`, { withCredentials: true });

      // ✅ Proceed if access is granted
      if (response.data.profile) {
        navigate(`/userpage/${userId}`);
      }
    } catch (error) {
      if (error.response && error.response.status === 403) {
        alert(error.response.data.error || "Upgrade your plan to view more profiles.");
      } else {
        showAlert("An error occurred while accessing the profile.");
      }
    }
  };


  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval); // Cleanup
  }, []);

  const fetchReviews = async () => {
    try {
      const response = await fetch("https://back.varankal.com/api/reviews");
      if (!response.ok) throw new Error("Failed to fetch reviews");
      const data = await response.json();
      setReviews(data);
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % reviews.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 3000);

    return () => clearInterval(interval);
  }, []);


  return (
    <>
      <MainNavbar />
      <div className="bg-white min-h-screen">
        <section className="lovely-section">
          <div className="content-grid">
            <div className="left-content">
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
                whileHover={{ scale: 1.1 }}
                className="main-heading"
              >
                Welcome to varankal Matrimony 💖
              </motion.h1>
              <p className="sub-heading">
                Find your perfect match. Connect. Chat. Build a future together.
              </p>

              <div className="features-containerA22">
                <motion.div
                  className="feature-itemA22"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <Heart className="feature-iconA22" />
                  <span>Verified Profiles for Trustworthy Connections</span>
                </motion.div>
                <motion.div
                  className="feature-itemA22"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <MessageCircle className="feature-iconA22" />
                  <span>Private Chats with Real-time Messaging</span>
                </motion.div>
                <motion.div
                  className="feature-itemA22"
                  whileHover={{ scale: 1.05 }}
                  transition={{ duration: 0.3 }}
                >
                  <Users className="feature-iconA22" />
                  <span>Interactive Community Events</span>
                </motion.div>
              </div>
            </div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.2 }}
              whileHover={{ scale: 1.05 }}
              className="explore-btn-container"
            >

              <div className="right-side-image-container enhanced-image-container relative overflow-hidden">
                <div className="background-glow"></div>

                <AnimatePresence mode="wait">
                  <motion.img
                    key={images[currentImageIndex]} // Important for animation!
                    src={images[currentImageIndex]}
                    alt="Lovely Pair Illustration"
                    className="right-side-image enhanced-image shadow-xl rounded-3xl"
                    initial={{ opacity: 0, scale: 0.95 }}
                    animate={{ opacity: 1, scale: 1 }}
                    exit={{ opacity: 0, scale: 1.05 }}
                    transition={{ duration: 1, ease: "easeInOut" }}
                  />
                </AnimatePresence>

                {/* Floating Emojis & Animated Elements */}
                <motion.div
                  className="image-overlay-icons"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 1.5 }}
                >

                </motion.div>

                {/* Gradient Animated Shapes */}
                {[1, 2, 3].map((shape) => (
                  <motion.div
                    key={shape}
                    className={`gradient-shape shape-${shape}`}
                    animate={{ x: shape % 2 === 0 ? [-20, 20, -20] : [0, 30, 0], y: [10, -10, 10] }}
                    transition={{ repeat: Infinity, duration: 6 + shape }}
                  ></motion.div>
                ))}

                {/* Overlay Gradient Effect */}
                <div className="overlay-gradient absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-30"></div>
              </div>
            </motion.div>
          </div>

          <div className="explore-btn-container">
            <Link to="/homelist" className="explore-btn hover:shadow-2xl transition-all duration-300">
              Explore Profiles
            </Link>
          </div>
        </section>

        {showProfileModal && (
          <div className="modal-backdropR" role="dialog" aria-modal="true" aria-labelledby="modalTitleR">
            <div className="modal-boxR animateFadeInR">
              <GiPartyPopper className="modal-iconR" />
              <h2 id="modalTitleR" className="modal-titleR">Complete Your Profile</h2>
              <p className="modal-descriptionR">
                To find your perfect match, please complete your profile. This helps us tailor suggestions just for you.
              </p>
              <div className="modal-buttonsR">
                <button
                  className="modal-buttonR modal-skip-btnR"
                  onClick={() => setShowProfileModal(false)}
                  aria-label="Skip profile creation for now"
                >
                  Skip
                </button>
                <button
                  className="modal-buttonR modal-create-btnR"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    navigate('/register');
                  }}
                  aria-label="Create your profile now"
                >
                  Create Profile Now
                </button>

              </div>
            </div>
          </div>
        )}


        {/* <section className="cta-section">
  <motion.h2
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 1 }}
    className="cta-heading"
  >
    Find Your Perfect Match 💕
  </motion.h2>
  <p className="cta-subtext">
    Search for someone special and start your journey today.
  </p>
  <section>
      <div className="cta-search-container">
        <div className="cta-dropdown-group1">
          <select
            className="cta-select"
            onChange={(e) => handleChange("age", e.target.value)}
          >
            <option value="">Select Age</option>
            {[...Array(43)].map((_, i) => {
              const age = i + 21;
              return (
                <option key={`age-${age}`} value={age}>
                  {age}
                </option>
              );
            })}
          </select>
        </div>

        <div className="cta-dropdown-group">
          <select
            className="cta-select"
            onChange={(e) => handleChange("occupation", e.target.value)}
          >
            <option value="">Select Occupation</option>
            <option value="engineer">Engineer</option>
            <option value="doctor">Doctor</option>
            <option value="teacher">Teacher</option>
            <option value="business">Business</option>
            <option value="student">Student</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div className="cta-dropdown-group">
          <select
            className="cta-select"
            onChange={(e) => handleChange("caste", e.target.value)}
          >
            <option value="">Select Caste</option>
            <option value="general">General</option>
            <option value="obc">OBC</option>
            <option value="sc">SC</option>
            <option value="st">ST</option>
            <option value="others">Others</option>
          </select>
        </div>

      
        <div className="cta-dropdown-group">
          <select
            className="cta-select"
            onChange={(e) => handleChange("location", e.target.value)}
          >
            <option value="">Select Location</option>
            <option value="delhi">Delhi</option>
            <option value="mumbai">Mumbai</option>
            <option value="bangalore">Bangalore</option>
            <option value="chennai">Chennai</option>
            <option value="kolkata">Kolkata</option>
            <option value="hyderabad">Hyderabad</option>
            <option value="other">Other</option>
          </select>
        </div>
<button className="cta-search-button">Find Matches 💘</button>
      </div>
    </section>
</section> */}

        <section className="featured-sectionK22">
          <h2>💖 Featured Profiles</h2>
          <p>Find your perfect match among our verified & premium members.</p>

          <div className="profile-containerK22">
            {featuredMembers.length > 0 ? (
              featuredMembers.map((member, index) => {
                const {
                  name = 'Unknown',
                  age = 'N/A',
                  gender = 'Not specified',
                  occupation = 'Profession not provided',
                  location = 'Location not available',
                  profilePic,
                } = member.profileDetails || {};

                const userId = member.userId;

                const isBase64 = profilePic && !profilePic.startsWith('http');
                const profileImageSrc = profilePic
                  ? isBase64
                    ? `data:image/jpeg;base64,${profilePic}`
                    : profilePic
                  : 'https://via.placeholder.com/100';

                return (
                  <div key={index} className="profile-cardK22">
                    <div className="profile-image-containerK22">
                      <img
                        src={profileImageSrc}
                        alt={`${name}'s profile`}
                        className="profile-imageK22"
                      />
                      <div className="profile-detailsK22">
                        <h3>{name}, {age}</h3>
                        <p>Gender: {gender}</p>
                        <p>{occupation}</p>
                        <p>{location}</p>
                      </div>
                    </div>
                    <button
                      className="view-profile-btnK22"
                      onClick={() => {
                        if (!userId) {
                          showAlert("User ID is not available.");
                          return;
                        }
                        handleProfileClick(userId);
                      }}
                    >
                      View Profile
                    </button>
                  </div>
                );
              })
            ) : (
              <p>No featured members available.</p>
            )}
          </div>
        </section>


        <div className="feature-section1123">
          <div className="feature-header1123">
            <p className="feature-subtitle1123">FEATURES TO</p>
            <h2 className="feature-title1123">Choose Varankal Matrimony</h2>
          </div>
          <div className="feature-grid1123">
            {featuresData.map((feature, index) => (
              <div className="feature-card1123" key={index}>
                <div className="feature-icon1123">{feature.icon}</div>
                <div>
                  <h3 className="feature-name1123">{feature.title}</h3>
                  <p className="feature-desc1123">{feature.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <h2 className="mentor-support-title1123">Varankal Matrimony Mentor Support</h2>
        <div className="steps-section1123">
          <div className="center-image1123">
            <img src="/Images/mentor1.jpg" alt="wedding couple" />
          </div>
          <div className="left-steps1123">
            {steps.slice(0, 2).map((step) => (
              <div key={step.number} className="step-card1123">
                <div className="step-number1123" style={{ backgroundColor: step.color }}>
                  {step.number}
                </div>
                <div className="step-content1123">
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
            <div className="right-steps1123">
              {steps.slice(2).map((step) => (
                <div key={step.number} className="step-card1123">
                  <div className="step-number1123" style={{ backgroundColor: step.color }}>
                    {step.number}
                  </div>
                  <div className="step-content1123">
                    <h3>{step.title}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="homepage-container">
            <header className="hero-section">
              <div className="hero-text">
                <h1>Discover Astrology Services 🔮</h1>
                <p>Get personalized guidance and meaningful astrological insights to navigate your life’s path with clarity and confidence.</p>
                <div className="step-text-block">
                  <div className="step-item">
                    <h4><FaSearchLocation className="step-icon" /> Locate</h4>
                    <p>Find astrologers based on your location and specific needs, ensuring personalized support.</p>
                  </div>

                  <div className="step-item">
                    <h4><GiCrystalBall className="step-icon" /> Book</h4>
                    <p>Schedule your session with ease at a time that suits your lifestyle.</p>
                  </div>

                  <div className="step-item">
                    <h4><FaPhoneAlt className="step-icon" /> Connect</h4>
                    <p>Speak directly with experienced astrologers and receive meaningful guidance and insights.</p>
                  </div>
                </div>
                <button
                  className="explore-btn2"
                  onClick={() => {
                    window.scrollTo(0, 0);
                    window.location.href = "/astrology";
                  }}
                >
                  Read More Stories
                </button>

              </div>
              <img src="/Images/astrologer.jpg" alt="Astrologer" className="hero-img" />
            </header>


          </div>
        </div>
        <div className="review-section">
          <h2 className="cta-user-feedback-title">What Our Users Say 💕</h2>
          <div className="review-container">
            {loading && <p style={{ textAlign: "center" }}>Loading reviews...</p>}
            {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}
            {reviews.map((review, i) => (
              <motion.div
                key={i}
                className={`review-card ${i === index ? "active" : "inactive"}`}
                whileHover={{ scale: 1.05 }}
              >
                <img
                  src={`https://back.varankal.com/${review.image?.replace(/\\/g, "/")}`}
                  alt={review.user}
                  className="user-image"
                />
                <FaQuoteLeft className="quote-icon" />
                <p className="review-text">"{review.text}"</p>
                <div className="stars">
                  {Array.from({ length: Math.floor(review.rating) }, (_, i) => (
                    <FaStar key={i} className="star" />
                  ))}
                  {review.rating % 1 !== 0 && <FaStarHalfAlt className="star" />}
                </div>
                <h4 className="user-name">- {review.user}</h4>
                <p className="user-meta"><FaThumbsUp /> {review.impressiveType}</p>
              </motion.div>
            ))}
          </div>
        </div>

      </div>
    </>
  );
};

export default HomePage;
